// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_CriaUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/criaUsuario
 *
 * Creates a new user in Cognito.
 */
import { registerContract } from './validate'

export interface Usuarios_CriaUsuarioInput {
username: string
password: string
name: string
documento: string
email: string
phone_number: string
language?: string
bgcolor?: string
mcp_scopes?: string
dw_scopes?: string
}

registerContract('Usuarios_CriaUsuarioInput', {
  username:     { type: 'string',  required: true },
  password:     { type: 'string',  required: true },
  name:         { type: 'string',  required: true },
  documento:    { type: 'string',  required: true },
  email:        { type: 'string',  required: true },
  phone_number: { type: 'string',  required: true },
  language:     { type: 'string',  required: false },
  bgcolor:      { type: 'string',  required: false },
  mcp_scopes:   { type: 'string',  required: false },
  dw_scopes:    { type: 'string',  required: false },
})
